import JSXComponent from "../../../../dist/jsx-render/JSXComponent";
import dom from "../../../../dist/jsx-render/dom";
import { IWidgetComponent } from "./IWidgetComponent";
import { MsoTable, MsoTableProps } from "../../Table/MsoTable";
import { EditTypes } from "../../Table/EditTypes";
import { app } from "../../../Frame/App";
import { WidgetDesignTable } from "../Widgets/WidgetDesignTable";
import { DesignParser } from "./Util/DesignParser";

export type WidgetDesignTableComponentProps = {
    widget: WidgetDesignTable;
    title: string;
    viewType: string;
    viewId: number;
    markup: string;
    styles: string;
    clientId: string;
}

export class WidgetDesignTableComponent extends JSXComponent implements IWidgetComponent {
    props: WidgetDesignTableComponentProps;

    constructor(props: WidgetDesignTableComponentProps) {
        super(props);
    }

    public element: HTMLElement;
    getElement = () => {
        this.element = <div className={`widget Background-Blur-90-MSO ${this.props.clientId}`}>
                 <div className="content-row">

                </div>
        </div>;
    }

    renderTable(): HTMLElement {

        // hier den edittype für die gewählte ansicht bestimmen, wenn man andere Objekte als Maßnahmen darstellen möchte.

        if (this.props.viewType || this.props.viewId) {
            let div: HTMLElement = <div className="mso-table"></div>;

            let tableProps: MsoTableProps = {
                loadOnCreate: true,
                enableScroll: true,
                enableSort: true,
                enableFilterPopup: true,
                editType: EditTypes.MeasureFullscreen,
                viewType: this.props.viewType,
                viewIndex: 42,
                viewId: this.props.viewId,
                hideHeader: true,
                loadUrl: app.resolveUrl("~/api/tableView/get")
            };

            if (this.props.widget.props.rowClickPageId) {
                tableProps.editType = EditTypes.None;
                tableProps.rowClickCallback = (ev: MouseEvent) => {
                    let target = event.target as HTMLElement;
                    let row = target.closest(".mt-content-row");
                    let id = Number(row.getAttribute("data-id"));

                    window.location.href = app.resolveUrl(`~/measures?layoutId=${this.props.widget.props.rowClickPageId}&parentId=${id}`);
                }
            }
            let table = new MsoTable(div, tableProps);

            return div;
        }
        else {
            let div: HTMLElement = <div className="missing-props">{Resources["WidgetClient"].missingProps}</div>;
            return div;
        }
    }

    parseDesign = () => {
        const container = this.element.querySelector(".content-row") as HTMLElement;
        app.destroyDomChildren(container);

        if (container) {
            DesignParser.parseDesign(container, this.props.markup);

            // this.props.design must contain <div class="table-placeholder" />
            const tablePlaceholder = container.querySelector(".table-placeholder") as HTMLElement;
            if (tablePlaceholder) {
                const parent = tablePlaceholder.parentElement;
                parent.insertBefore(this.renderTable(), tablePlaceholder);
                app.destroyDomElements(tablePlaceholder);
            }
        }
    }

    appendStyles = () => {
        DesignParser.appendStyles(this.props.clientId, this.props.styles);
    }

    public render(): HTMLElement {
        this.getElement();

        this.props.widget.setGridPosition();

        // Parse design and create HTMLElements and Table
        this.parseDesign();
        this.appendStyles();

        return this.element;
    }
}